module.exports = __webpack_public_path__ + "static/media/me.6411bc60.jpg";